/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.components').service('CollaboratorsService', function (
    this: JS5Object, _: JS5Object, CollaboratorsResourceFactory: JS5Object, ContentResourceFactory: JS5Object,
    $q:JS5Object) {
    this.permissionViewState = 'COLLABORATOR_VIEW_STATE';
    this.originalEditData = {};
    this.newActor = null;

    this.getAllCollaborators = (queryParams: JS5Object, queryHandler: JS5Function) => {
        return CollaboratorsResourceFactory.all(queryParams, queryHandler).$promise;
    };
    this.getCollaboratorById = (queryParams: JS5Object, queryHandler: JS5Function) => {
        return CollaboratorsResourceFactory.byId(queryParams, queryHandler).$promise;
    };
    this.getCollaboratorRoles = (queryParams: JS5Object, queryHandler: JS5Function) => {
        return CollaboratorsResourceFactory.roles(queryParams, queryHandler).$promise;
    };

    this.getCollaboratorRole = (queryParams: JS5Object) => {
        return CollaboratorsResourceFactory.getRole(queryParams).$promise;
    };

    this.saveCollaboratorRole = (collaboratorRole: JS5Object) => {
        return CollaboratorsResourceFactory.saveRole(collaboratorRole).$promise;
    };

    this.updateCollaboratorRole = (collaboratorRole: JS5Object) => {
        return CollaboratorsResourceFactory.updateRole(collaboratorRole).$promise;
    };

    this.deleteCollaboratorRole = (queryParams: JS5Object, collaboratorRole: JS5Object) => {
        return CollaboratorsResourceFactory.deleteRole(queryParams, collaboratorRole).$promise;
    };
    this.deleteCollaboratorRoles = (collaboratorRoles: Array<JS5Object>) => {
        let collaboratorRoleDeletePromises: Array<JS5Object> = [];
        collaboratorRoles.forEach((role: JS5Object) => {
            const criteria: JS5Object = {
                id: role.id
            };
            collaboratorRoleDeletePromises.push(CollaboratorsResourceFactory.deleteRole(criteria, role.id).$promise);
        });
        return $q.all(collaboratorRoleDeletePromises);
    };
    this.saveNewCollaborator = (collaborator: JS5Object, queryHandler: JS5Function) => {
        return CollaboratorsResourceFactory.save({}, collaborator, queryHandler).$promise;
    };
    this.updateCollaborator = (collaborator: JS5Object, queryHandler: JS5Function) => {
        return CollaboratorsResourceFactory.update({}, collaborator, queryHandler).$promise;
    };
    this.deleteCollaborator = (collaborator: JS5Object, queryHandler: JS5Function) => {
        return CollaboratorsResourceFactory.delete({}, collaborator, queryHandler).$promise;
    };
    this.getContentActors = (criteria: JS5Object, queryHandler: JS5Function) => {
        return ContentResourceFactory.getActorsByContent(criteria, queryHandler).$promise
    };

    this.saveContentActor = (criteria: JS5Object, actor: JS5Object) => {
        return ContentResourceFactory.saveActorByContent(criteria, actor).$promise;
    };
    this.deleteContentActors = (criteria: JS5Object, actors: Array<JS5Object>) => {
        return ContentResourceFactory.deleteActorsByContent(criteria, actors).$promise;
    };
});
